export default __webpack_public_path__ + "static/media/OpenSans-Italic.20653d2f.ttf";